import React, { useEffect } from 'react';
import { FeedbackLayout } from './feedback.layout';
import { useAppActions } from '../../../overmind';
import { IFeedbackWidgetProps, RatingAssessmentCommentsSearchParams } from './feedback.models';
import { RatingAssessmentCommentsResponse } from '../../../models/overmind/assessment-analytics';
import { Sentiment } from '../../../enums/sentiment';

export function SkillSpecificFeedbackWidget({ isAnonymous, baseSearchParams, filtersOptions, isPerson }: IFeedbackWidgetProps): JSX.Element {
  const actions = useAppActions();

  const [comments, setComments] = React.useState<RatingAssessmentCommentsResponse>();
  const [isLoading, setIsLoading] = React.useState(false);
  const [searchParams, setSearchParams] = React.useState<RatingAssessmentCommentsSearchParams>({
    assessmentSlug: baseSearchParams.assessmentSlug,
    learnerSlug: baseSearchParams.learnerSlug,
    page: 1,
    pageSize: 5,
    search: undefined,
  });

  async function getData(params: RatingAssessmentCommentsSearchParams) {
    const response = await actions.getAssessmentAnalyticsSkillComments(params);
    setComments(response);
  }

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      await getData(searchParams);
      setIsLoading(false);
    }
    fetchData();
  }, [baseSearchParams.assessmentSlug, baseSearchParams.learnerSlug, searchParams.page]);

  return (
    <FeedbackLayout
      isAnonymous={isAnonymous}
      isPerson={isPerson}
      isLoading={isLoading}
      title={'Skill specific feedback'}
      subtitle="A list of feedback for a person per skill that was given in the assessment."
      data={comments}
      handleDownloadCSV={async () => {
        await actions.getAssessmentAnalyticsSkillCommentsCSV({ ...searchParams, page: undefined, pageSize: undefined });
      }}
      filtersOptions={filtersOptions}
      handleSearchQuery={async search => {
        const newSearchParams = {
          ...searchParams,
          search,
          page: 1,
        };
        setSearchParams(newSearchParams);
        await getData(newSearchParams);
      }}
      handlePageChange={async (page: number) => {
        const newSearchParams = { ...searchParams, page };
        setSearchParams(newSearchParams);
        await getData(newSearchParams);
      }}
      handleFiltersChange={async selectedFilters => {
        setIsLoading(true);
        const filterValues = {
          skillSlug: selectedFilters.find(f => f.filterType === 'skills')?.slug.replace('skills', ''),
          learnerSlug: selectedFilters.find(f => f.filterType === 'subjects')?.slug.replace('subjects', ''),
          reviewerSlug: selectedFilters.find(f => f.filterType === 'assessors')?.slug.replace('assessors', ''),
          sentiment: selectedFilters.find(f => f.filterType === 'sentiment')?.slug.replace('sentiment', '') as Sentiment,
        };

        const newSearchParams = {
          ...searchParams,
          ...filterValues,
        };

        setSearchParams(newSearchParams);
        await getData(newSearchParams);
        setIsLoading(false);
      }}
    />
  );
}
